/*
  Keranova - Hide products by metafield (custom.hide_product)

  IMPORTANT:
  - JavaScript cannot read Shopify metafields by itself.
  - Your Liquid templates/snippets must output a marker attribute on each product card, e.g.:
      data-hide-product="{{ product.metafields.custom.hide_product.value | default: false | json }}"

  This script will then hide/remove those product cards across:
  - homepage product grids
  - collection grids
  - search results / predictive search
  - recently viewed
  - related/recommended/complementary products

  It also re-applies when content is injected dynamically (AJAX / section rendering).
*/

(function () {
  'use strict';

  var CONFIG = {
    attr: 'data-hide-product',
    hiddenClass: 'keranova-hidden-product',
    // When we find an element with data-hide-product, we hide the closest card container.
    cardClosestSelectors: [
      '[data-product-card]',
      '.product',
      '.product-item',
      '.product-card',
      '.card',
      '.grid__item',
      'li',
      'article'
    ].join(',')
  };

  function toBoolean(value) {
    if (value === true) return true;
    if (value === false) return false;
    if (value == null) return false;

    var v = String(value).trim().toLowerCase();
    return v === 'true' || v === '1' || v === 'yes' || v === 'y';
  }

  function getHideFlag(node) {
    if (!node || node.nodeType !== 1) return false;
    return toBoolean(node.getAttribute(CONFIG.attr));
  }

  function getCardContainer(node) {
    if (!node || node.nodeType !== 1) return null;
    return node.closest(CONFIG.cardClosestSelectors) || node;
  }

  function hideNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.classList.contains(CONFIG.hiddenClass)) return;

    node.classList.add(CONFIG.hiddenClass);

    // Best-effort hiding for different layouts.
    node.setAttribute('hidden', 'hidden');
    node.setAttribute('aria-hidden', 'true');
    node.style.display = 'none';
    node.style.visibility = 'hidden';
    node.style.pointerEvents = 'none';
  }

  function apply(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes;

    try {
      nodes = scope.querySelectorAll('[' + CONFIG.attr + ']');
    } catch (e) {
      return;
    }

    for (var i = 0; i < nodes.length; i++) {
      var marker = nodes[i];
      if (!getHideFlag(marker)) continue;
      var card = getCardContainer(marker);
      hideNode(card);
    }
  }

  function observeDom() {
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || m.addedNodes.length === 0) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;

          // If the added node itself is a marker, or contains markers.
          if (n.hasAttribute && n.hasAttribute(CONFIG.attr)) {
            if (getHideFlag(n)) hideNode(getCardContainer(n));
          }

          apply(n);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function bindShopifyEvents() {
    document.addEventListener('shopify:section:load', function (e) {
      apply(e && e.target ? e.target : document);
    });

    document.addEventListener('shopify:section:reorder', function (e) {
      apply(e && e.target ? e.target : document);
    });

    document.addEventListener('shopify:block:select', function (e) {
      apply(e && e.target ? e.target : document);
    });
  }

  function init() {
    apply(document);
    observeDom();
    bindShopifyEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Optional manual API
  window.KeranovaHideProduct = window.KeranovaHideProduct || {};
  window.KeranovaHideProduct.apply = apply;
})();
